import React from 'react';
import { useKirbyDemoContent } from '../../hooks/useKirbyData';
import { getYouTubeEmbedUrl } from '../../utils/youtube';
import * as Styled from './TutorialsDemoPage.styles';
import './TutorialPage.scss';

const TutorialsDemoPage: React.FC = () => {
  const { data: demoContent } = useKirbyDemoContent();

  let height = '400';
  if (demoContent?.online_demo_iframe_show && demoContent.online_demo_iframe_url) {
    const query = demoContent.online_demo_iframe_url.split('?')[1];
    if (query) {
      const size = new URLSearchParams(query).get('size');
      if (size) {
        height = size;
      }
    }
  }

  const videoEmbedUrl =
    demoContent?.online_demo_video_active && demoContent.online_demo_video_url
      ? getYouTubeEmbedUrl(demoContent.online_demo_video_url, !!demoContent.online_demo_video_autoplay)
      : null;

  return (
    <div className='tutorial'>
      <div className='tutorial-wrapper' style={{ paddingBottom: '0px' }}>
        <div className='left'>
          <div className='body-wrapper'>
            {videoEmbedUrl && (
              <div className='header-video'>
                <iframe
                  src={videoEmbedUrl}
                  title={demoContent?.online_demo_title ?? 'Online-Demo'}
                  allow='accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share'
                  allowFullScreen
                  loading='lazy'
                />
              </div>
            )}

            {demoContent?.online_content_show && demoContent.online_content && (
              <Styled.Content dangerouslySetInnerHTML={{ __html: demoContent.online_content }} />
            )}
          </div>
        </div>
      </div>

      {demoContent?.online_demo_iframe_show && demoContent.online_demo_iframe_url && (
        <Styled.IFrame height={height} title='SOLID Online-Demo' src={demoContent.online_demo_iframe_url} />
      )}
    </div>
  );
};

export default TutorialsDemoPage;
